import { Organization } from '~/api/data/user/types';

export default function chooseManagedSpace(managedOrganizations: Organization[] | undefined) {
  const space = managedOrganizations?.[0]?.firstSpace;

  return space ? space : null;
}
